import { Construction } from "@mui/icons-material";
import { useMediaQuery } from "@mui/material";
import { useState } from "react";
import { API } from "../../lib/api";
import { FormProvider } from "../../contexts/CreateRecordFormContext";
import CollapsibleGridCard from "../CollapsibleGridCard";
import RecordModal from "../RecordModal/RecordModal";
import DashboardForecastingColumns from "../../lib/TableColumns/DashboardForecastingColumns";
import { GRID_SESSION_KEYS } from "../../lib/gridSessionState";

const ForecastingTable = ({ opportunities, setOpportunities, setFeedback }) => {
    const [selectedRows, setSelectedRows] = useState([]);
    const [openUpdateModal, setOpenUpdateModal] = useState(false);
    const isMobile = useMediaQuery('(max-width:600px)');
    const columns = DashboardForecastingColumns({ isMobile });

    const handleSelectionChange = (selection) => setSelectedRows(selection);
    const handleOpenUpdateModal = () => selectedRows.length ? setOpenUpdateModal(true) : setFeedback({ open: true, message: "Select at least one record to update!", type: "info" });
    const handleCloseUpdateModal = () => setOpenUpdateModal(false);

    const updateForecastingFields = [
        { name: "shipDate", label: "Ship Date", type: "date", helperText: "This will update the ship date on every revenue line for each selected opportunity." },
        { name: "winProbability", label: "Win Percentage", type: "number" },
        { name: "closeDate", label: "Close Date", type: "date" },
        { name: "salesStage", label: "Stage", type: "autocomplete", options: ['01 - Lead', '02 - Identified', '06 - Quote Sent', '08 - Won'] },
    ];

    const actionButtons = [
        { title: "Update Selected Forecasting Opportunities", onClick: handleOpenUpdateModal, icon: Construction, color: "primary" },
    ];

    const handleUpdateSubmit = async (formData) => {
        const updatedFields = {};

        Object.keys(formData).forEach(key => {
            if (formData[key] !== "" && formData[key] != null) {
                updatedFields[key] = formData[key];
            }
        });

        if (!Object.keys(updatedFields).length) {
            setFeedback({ open: true, message: "Choose at least one field to update.", type: "info" });
            return;
        }

        const response = await API.Opportunities.UpdateDashboardForecasting(selectedRows, updatedFields);

        if (response.status === 200) {
            const refreshedResponse = await API.Reporting.DashboardForecasting();
            setOpportunities(refreshedResponse.status === 200 ? refreshedResponse.data : []);
            setFeedback({ open: true, message: response.data.message, type: "success" });
            setSelectedRows([]);
            handleCloseUpdateModal();
        } else {
            setFeedback({ open: true, message: response?.data?.message || "Error updating forecasting opportunities...", type: "error" });
        }
    };

    return (
        <FormProvider>
            <RecordModal open={openUpdateModal} handleClose={handleCloseUpdateModal} fields={updateForecastingFields} title={"Update Selected Forecasting Opportunities"} onSubmit={handleUpdateSubmit} />
            <CollapsibleGridCard
                title="Forecasting"
                description="Opportunities allowed in the forecast with revenue lines scheduled to ship in the next 12 months. Opportunities with project numbers are excluded."
                rows={opportunities || []}
                columns={columns}
                getRowId={(row) => row._id}
                checkboxSelection
                rowSelectionModel={selectedRows}
                onRowSelectionModelChange={handleSelectionChange}
                actionButtons={actionButtons}
                sessionStorageKey={GRID_SESSION_KEYS.dashboardForecasting}
                sessionUserId={localStorage.getItem("id")}
                initialPageSize={10}
                pageSizeOptions={[10, 25, 50]}
                variantClassName="hive-dashboard-opps-card"
                headerClassName="hive-dashboard-opps-header"
                titleClassName="hive-dashboard-opps-title"
                toggleClassName="hive-dashboard-opps-toggle"
                contentClassName="hive-dashboard-opps-content"
                gridClassName="hive-dashboard-opps-data-grid"
                actionButtonsClassName="hive-dashboard-opps-actions"
                titleStyle={{ margin: 0 }}
            />
        </FormProvider>
    );
};

export default ForecastingTable;
